module.exports = __webpack_public_path__ + "static/media/home-music-icon.641b9dc2.png";